<template>
  <div class="monitor-container">
    <!-- 顶部状态栏 -->
    <div class="top-bar">
      <div class="time-info">
        <span class="date">{{ currentDate }} 星期{{ weekDay }}</span>
        <span class="time">{{ currentTime }}</span>
      </div>
      <div class="top-stats">
        <div class="stat-item">
          <span class="label">机台总数</span>
          <span class="value">{{ totalMachines }}</span>
        </div>
        <div class="stat-item">
          <span class="label">生产计数</span>
          <span class="value">{{totalProduction}}</span>
        </div>
        <div class="stat-item">
          <span class="label">不良计数</span>
          <span class="value">{{ totalBadProduction }}</span>
        </div>
      </div>
      <div>
        <el-button type="primary" size="small" ghost @click="handleConfig">配置</el-button>
        <el-button type="primary" size="small" @click="toggle">{{ isFullscreen ? '退出全屏' : '全屏' }}</el-button>
      </div>
     
    </div>

    <!-- 主体内容区 -->
    <div class="main-content">
      <!-- 左侧列 -->
      <div class="left-column">
        <!-- 环境模块 -->
        <dv-border-box-1 class="module-card module-card-content">
          <template #title>
            <span class="module-title">环境</span>
          </template>
          <div class="env-grid">
            <div class="env-item">
              <span class="env-label">光照(Lux)</span>
              <span class="env-value">123</span>
            </div>
            <div class="env-item">
              <span class="env-label">噪音(db)</span>
              <span class="env-value">55</span>
            </div>
            <div class="env-item">
              <span class="env-label">温度(℃)</span>
              <span class="env-value">37</span>
            </div>
            <div class="env-item">
              <span class="env-label">湿度(%)</span>
              <span class="env-value">43</span>
            </div>
            <div class="env-item">
              <span class="env-label">PM2.5(m³)</span>
              <span class="env-value">20</span>
            </div>
            <div class="env-item">
              <span class="env-label">硫化氢(PPM)</span>
              <span class="env-value">15</span>
            </div>
            <div class="env-item">
              <span class="env-label">氮气(PPM)</span>
              <span class="env-value">50</span>
            </div>
          </div>
        </dv-border-box-1>

        <!-- 产能模块 -->
        <dv-border-box-13 class="module-card">
          <template #title>
            <span class="module-title">产能</span>
          </template>
          <div ref="capacityChart" class="chart-container"></div>
        </dv-border-box-13>

        <!-- 质量模块 -->
        <dv-border-box-1 class="module-card">
          <template #title>
            <span class="module-title">质量</span>
          </template>
          <div ref="qualityChart" class="chart-container"></div>
        </dv-border-box-1>
      </div>

      <!-- 中间列 -->
      <div class="center-column">
        <!-- 产品图片 -->
        <div class="product-img-container">
          <img src="../assets/vite.svg"  alt="产品图" class="product-img" />
        </div>

        <!-- 报警记录 -->
        <dv-border-box-8 class="module-card alarm-card">
          <template #title>
            <span class="module-title">报警记录</span>
          </template>
          <div class="alarm-list">
            <div v-for="(item, index) in alarmList" :key="index" class="alarm-item">
              <span class="alarm-index">{{ String(index + 1).padStart(2, '0') }}</span>
              <span class="alarm-content">{{ item.content }}</span>
              <span class="alarm-time">{{ item.time }}</span>
              <span class="alarm-duration">时长{{ item.duration }}秒</span>
            </div>
          </div>
        </dv-border-box-8>

        <!-- 数据异常报警比例 -->
        <dv-border-box-8 reverse class="module-card alarm-card">
          <template #title>
            <span class="module-title">数据异常报警比例</span>
          </template>
          <div ref="alarmRatioChart" class="chart-container"></div>
        </dv-border-box-8>
      </div>

      <!-- 右侧列 -->
      <div class="right-column">
        <!-- 设备模块 -->
        <dv-border-box-1 class="module-card module-card-content">
          <template #title>
            <span class="module-title">设备</span>
          </template>
          <div class="env-grid">
            <div class="env-item">
              <span class="env-label">电能(Kw.h)</span>
              <span class="env-value">60.8</span>
            </div>
            <div class="env-item">
              <span class="env-label">电压(V)</span>
              <span class="env-value">390</span>
            </div>
            <div class="env-item">
              <span class="env-label">电流(A)</span>
              <span class="env-value">5</span>
            </div>
            <div class="env-item">
              <span class="env-label">压差(kpa)</span>
              <span class="env-value">13</span>
            </div>
            <div class="env-item">
              <span class="env-label">温度(℃)</span>
              <span class="env-value">36</span>
            </div>
            <div class="env-item">
              <span class="env-label">震动(mm/s)</span>
              <span class="env-value">4.1</span>
            </div>
            <div class="env-item">
              <span class="env-label">转速(r/min)</span>
              <span class="env-value">2600</span>
            </div>
            <div class="env-item">
              <span class="env-label">气压(kpa)</span>
              <span class="env-value">0.5</span>
            </div>
          </div>
        </dv-border-box-1>

        <!-- 能耗模块 -->
        <dv-border-box-13 class="module-card">
          <template #title>
            <span class="module-title">能耗</span>
          </template>
          <div ref="energyChart" class="chart-container"></div>
        </dv-border-box-13>

        <!-- 人力模块 -->
        <dv-border-box-1 class="module-card">
          <template #title>
            <span class="module-title">人力</span>
          </template>
          <div class="人力-container">
            <div class="staff-count">
              <span class="count-label">在职在岗</span>
              <span class="count-num">870</span>
            </div>
            <div class="vacancy-list">
              <!-- <div class="vacancy-title">缺岗统计</div> -->
              <div v-for="(item, index) in vacancyList" :key="index" class="vacancy-item">
                <el-icon :size="12" color="#f90"><Bell /></el-icon>
                <span class="vacancy-name">{{ item.name }}</span>
                <span class="vacancy-post">{{ item.post }}</span>
                <div class="vacancy-bar">
                  <div class="bar-fill" :style="{ width: `${item.value}px` }"></div>
                </div>
                <span class="vacancy-value">{{ item.value }}</span>
              </div>
            </div>
          </div>
        </dv-border-box-1>
      </div>
    </div>

    <!-- 底部车间状态 -->
    <div class="bottom-workshop">
      <div class="workshop-card" v-for="(item, index) in workshopList" :key="index">
        <div class="workshop-header">
          <span class="workshop-name">{{ item.name }}</span>
          <el-button type="text" size="small" class="detail-btn">[详情]</el-button>
        </div>
        <div class="workshop-stats">
          <div class="stat-row">
            <div class="stat-col">
              <span class="stat-label">机台总数</span>
              <span class="stat-value total">{{ item.total }}</span>
            </div>
            <div class="stat-col">
              <span class="stat-label">作业</span>
              <span class="stat-value work">{{ item.work }}</span>
            </div>
            <div class="stat-col">
              <span class="stat-label">等待</span>
              <span class="stat-value wait">{{ item.wait }}</span>
            </div>
            <div class="stat-col">
              <span class="stat-label">故障</span>
              <span class="stat-value fault">{{ item.fault }}</span>
            </div>
            <div class="stat-col">
              <span class="stat-label">停机</span>
              <span class="stat-value stop">{{ item.stop }}</span>
            </div>
          </div>
          <div class="stat-row">
            
          </div>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <div class="footer">
      <span>个人开发使用,需要授权使用</span>
    </div>
  </div>
</template>

<script setup>

import screenfull from 'screenfull';
import { ref, onMounted, onUnmounted } from 'vue'
import * as echarts from 'echarts'
import { ElIcon } from 'element-plus'
import { Bell } from '@element-plus/icons-vue'
import showMessage from '../utils/showMessage'
import request from '../utils/request'
// ==========================================
// 【核心】从后端获取所有大屏数据
// ==========================================
// 直接用！
const loadData = async () => {
  const data = await request.get('/monitor/data')
  console.log('获取到的数据:',  data)
  showMessage('success','数据获取成功')
  showMessage('error','我是显示失败效果')
  showMessage('info','我是显示当前日期：'+currentDate.value)
  showMessage('info',data)
}
//全屏
const isFullscreen = ref(false);
const toggle = () => {
  if (screenfull.isEnabled) {
    screenfull.toggle();
    isFullscreen.value = !isFullscreen.value;
  }
};
// ===================== 数据定义（全部写死） =====================
// 时间相关
// const currentTime = ref('15:25:44')
// const currentDate = ref('2026-04-08')
// const weekDay = ref('三')

// ==================== WebSocket 实时数据 ====================
const realData = ref({
  totalMachines: 0,
  totalProduction: 0,
  totalBadProduction: 0,

})
let ws = null

// 连接 WebSocket
function connectWebSocket() {
  // 连接后端
  ws = new WebSocket('wss://localhost:5000/ws')
  console.log('连接 WebSocket')
  // 收到实时数据 → 自动更新页面
  ws.onmessage = (event) => {
    const data = JSON.parse(event.data)
    realData.value = data
    totalMachines.value = data.totalMachines
    totalProduction.value = data.totalProduction
    totalBadProduction.value = data.totalBadProduction    
    console.log('实时数据更新：', data)
  }

  // 断开自动重连
  ws.onclose = () => {
    console.log('断开连接，5秒后重连')
    setTimeout(connectWebSocket, 5000)
  }
}


const currentTime = ref('')
const currentDate = ref('')
const weekDay = ref('')
const weekMap = ['日', '一', '二', '三', '四', '五', '六']
let timeTimer = null
const pad2 = (n) => String(n).padStart(2, '0')
const updateDateTime = () => {
  const now = new Date()
  currentTime.value = `${pad2(now.getHours())}:${pad2(now.getMinutes())}:${pad2(now.getSeconds())}`
  currentDate.value = `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}`
  weekDay.value = weekMap[now.getDay()]}

const totalMachines = ref(289)
const totalProduction = ref(7485)
const totalBadProduction = ref(3246) 
// 报警记录
const alarmList = ref([
  { content: '设备温度过高', time: '2023-11-23 16:34:21', duration: 7 },
  { content: '车间温度过高', time: '2023-12-05 09:33:14', duration: 12 },
  { content: '设备转速过快', time: '2024-03-31 11:12:07', duration: 10 },
  { content: '设备气压偏低', time: '2024-09-24 20:41:47', duration: 90 }
])

// 缺岗统计
const vacancyList = ref([
  { name: '张三', post: '主管', value: 50 },
  { name: '王翠花', post: '技术工程师', value: 150 },
  { name: '李大仁', post: '人事专员', value: 102 },
  { name: '黄小琥', post: '研发工程师', value: 30 },
  { name: '谈三藏', post: '部门经理', value: 66 }
])

// 车间状态
const workshopList = ref([
  { name: '贴片车间', total: 40, work: 32, wait: 4, fault: 8, stop: 0 },
  { name: '封装车间', total: 28, work: 20, wait: 8, fault: 6, stop: 2 },
  { name: '焊接车间', total: 34, work: 26, wait: 12, fault: 2, stop: 6 },
  { name: '贴片车间', total: 94, work: 80, wait: 3, fault: 13, stop: 1 }
])

// 图表DOM引用
const capacityChart = ref(null)
const qualityChart = ref(null)
const alarmRatioChart = ref(null)
const energyChart = ref(null)

// 图表实例
let capacityInstance = null
let qualityInstance = null
let alarmRatioInstance = null
let energyInstance = null

// ===================== 方法定义 =====================
// 配置按钮点击
const handleConfig = () => {
  loadData() // 加载后端数据
  
  console.log('点击配置按钮')
}

// 初始化产能柱状图
const initCapacityChart = () => {
  capacityInstance = echarts.init(capacityChart.value)
  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' }
    },
    legend: {
      data: ['生产计数', '不良计数'],
      textStyle: { color: '#fff' },
      right: 20,
      top: 15
    },
    grid: {
      left: '5%',
      right: '5%',
      bottom: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: ['8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00'],
      axisLine: { lineStyle: { color: '#00d3ff' } },
      axisLabel: { color: '#fff' }
    },
    yAxis: {
      type: 'value',
      max: 500,
      axisLine: { lineStyle: { color: '#00d3ff' } },
      axisLabel: { color: '#fff' },
      splitLine: { lineStyle: { color: 'rgba(0, 211, 255, 0.2)' } }
    },
    series: [
      {
        name: '生产计数',
        type: 'bar',
        data: [300, 500, 480, 400, 470, 480, 350, 360],
        itemStyle: { color: '#00d3ff' },
        barWidth: '20%'
      },
      {
        name: '不良计数',
        type: 'bar',
        data: [50, 40, 20, 30, 20, 50, 10, 30],
        itemStyle: { color: '#ff6b6b' },
        barWidth: '20%'
      }
    ]
  }
  capacityInstance.setOption(option)
}

// 初始化质量折线图
const initQualityChart = () => {
  qualityInstance = echarts.init(qualityChart.value)
  const option = {
    tooltip: {
      trigger: 'axis'
    },
    grid: {
      left: '5%',
      right: '5%',
      bottom: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: ['1#', '2#', '3#', '4#', '5#', '6#'],
      axisLine: { lineStyle: { color: '#00d3ff' } },
      axisLabel: { color: '#fff' }
    },
    yAxis: {
      type: 'value',
      max: 10,
      axisLine: { lineStyle: { color: '#00d3ff' } },
      axisLabel: { color: '#fff' },
      splitLine: { lineStyle: { color: 'rgba(0, 211, 255, 0.2)' } }
    },
    series: [
      {
        name: '质量',
        type: 'line',
        smooth: true,
        data: [8, 3, 6, 3, 9, 2],
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: 'rgba(0, 211, 255, 0.6)' },
            { offset: 1, color: 'rgba(0, 211, 255, 0.1)' }
          ])
        },
        itemStyle: { color: '#00d3ff' },
        lineStyle: { width: 2, color: '#00d3ff' },
        symbol: 'circle',
        symbolSize: 6
      }
    ]
  }
  qualityInstance.setOption(option)
}

// 初始化报警比例环形图
const initAlarmRatioChart = () => {
  alarmRatioInstance = echarts.init(alarmRatioChart.value)
  const option = {
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      left: 'left',
      textStyle: { color: '#fff' },
    },
    series: [
      {
        name: '报警比例',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#0a1a30',
          borderWidth: 2
        },
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 20,
            fontWeight: 'bold',
            color: '#fff'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          { value: 30, name: '压差', itemStyle: { color: '#0099ff' } },
          { value: 35, name: '震动', itemStyle: { color: '#ff4d4f' } },
          { value: 10, name: '设备温度', itemStyle: { color: '#ffc107' } },
          { value: 25, name: '光照', itemStyle: { color: '#86909c' } }
        ]
      }
    ]
  }
  alarmRatioInstance.setOption(option)
}

// 初始化能耗图表（占位，可根据需求补充）
const initEnergyChart = () => {
  energyInstance = echarts.init(energyChart.value)
  const option = {
    tooltip: {
      trigger: 'axis'
    },
    grid: {
      left: '5%',
      right: '5%',
      bottom: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      axisLine: { lineStyle: { color: '#00d3ff' } },
      axisLabel: { color: '#fff' }
    },
    yAxis: {
      type: 'value',
      axisLine: { lineStyle: { color: '#00d3ff' } },
      axisLabel: { color: '#fff' },
      splitLine: { lineStyle: { color: 'rgba(0, 211, 255, 0.2)' } }
    },
    series: [
      {
        name: '能耗',
        type: 'line',
        data: [60.8, 58.2, 62.5, 59.3, 61.1, 57.8, 60.2],
        itemStyle: { color: '#00d3ff' },
        lineStyle: { width: 2, color: '#00d3ff' }
      }
    ]
  }
  energyInstance.setOption(option)
}

// 窗口大小变化时重绘图表
const resizeCharts = () => {
  capacityInstance?.resize()
  qualityInstance?.resize()
  alarmRatioInstance?.resize()
  energyInstance?.resize()
}

// ===================== 生命周期 =====================
onMounted(() => {
  // 连接 WebSocket
  connectWebSocket()
  // 初始化所有图表
  initCapacityChart()
  initQualityChart()
  initAlarmRatioChart()
  initEnergyChart()

  updateDateTime() // 先立即更新一次，避免初始空白
  timeTimer = setInterval(updateDateTime, 1000) // 每秒更新

  // 监听窗口大小变化
  window.addEventListener('resize', resizeCharts)
})

onUnmounted(() => {
  // 断开 WebSocket 连接
  ws?.close() 
  // 销毁图表实例
  capacityInstance?.dispose()
  qualityInstance?.dispose()
  alarmRatioInstance?.dispose()
  energyInstance?.dispose()



  // 移除监听
  window.removeEventListener('resize', resizeCharts)
})
</script>

<style scoped>
/* 全局容器 */
.monitor-container {
  width: 100vw;
  height: 100vh;
  background-color: #0a1a30;
  /* background-image: url('data:image/svg+xml,%3Csvg width="100" height="10" viewBox="0 0 100 10" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M0 5 L100 5" stroke="%2300d3ff" stroke-width="0.5" opacity="0.1"/%3E%3C/svg%3E'); */

  background-image: url('../assets/pageBg.png');
  color: #fff;
  font-family: 'Microsoft YaHei', sans-serif;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 顶部状态栏 */
.top-bar {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid rgba(0, 211, 255, 0.3);
  background: linear-gradient(to right, rgba(0, 211, 255, 0.1), transparent);
}

.time-info {
  display: flex;
  flex-direction: column;
}

.time {
  font-size: 20px;
  font-weight: bold;
  color: #00d3ff;
}

.date {
  font-size: 14px;
  color: #ccc;
}

.top-stats {
  display: flex;
  gap: 100px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-item .label {
  font-size: 14px;
  color: #ccc;
  margin-bottom: 5px;
}

.stat-item .value {
  font-size: 20px;
  font-weight: bold;
  color: #00d3ff;
  letter-spacing: 5px;
}

/* 主体内容区 */
.main-content {
  flex: 1;
  display: flex;
  padding: 5px 5px;
  gap: 10px;
  overflow: hidden;
}

/* 列布局 */
.left-column, .right-column {
  width: 32%;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.center-column {
  width: 36%;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

/* 模块卡片 */
.module-card {
  flex: 1;
  
  /* min-height: 200px; */
  --border-color: #00d3ff;
  --bg-color: rgba(10, 26, 48, 0.8);
  
}

.module-card-content {
  flex: 0 0 auto;
  height: 130px;
}
.module-title {
  font-size: 12px;
  font-weight: bold;
  color: #00d3ff;
  padding-left: 10px;
}

/* 环境/设备网格 */
.env-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0px;
  padding: 15px 10px;
  height: 100%;
  box-sizing: border-box;
}

.env-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 0px;
}

.env-label {
  font-size: 12px;
  color: #ccc;
  margin-bottom: 0px;
}

.env-value {
  font-size: 16px;
  font-weight: bold;
  color: #00d3ff;
}

/* 图表容器 */
.chart-container {
  width: 100%;
  height: 100%;
  min-height: 180px;
  padding: 0px 15px; /* 内边距缩小 */
  margin: -5px 0px;
}

/* 产品图片容器 */
.product-img-container {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 211, 255, 0.05);
  border: 1px solid rgba(0, 211, 255, 0.3);
  border-radius: 4px;
}

.product-img {
  max-height: 180px;
  max-width: 10%;
}

/* 报警记录 */
.alarm-card {
  flex: 0 0 auto;
  height: auto;
}

.alarm-list {
  padding: 5px 25px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
}

.alarm-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 211, 255, 0.1);
}

.alarm-item:last-child {
  border-bottom: none;
}

.alarm-index {
  color: #ff4d4f;
  font-weight: bold;
  min-width: 30px;
}

.alarm-content {
  flex: 1;
  font-size: 14px;
  color: #fff;
}

.alarm-time {
  color: #ccc;
  font-size: 14px;
}

.alarm-duration {
  color: #00d3ff;
  font-size: 14px;
}

/* 人力模块 */
.人力-container {
  padding: 10px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.staff-count {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.count-num {
  font-size: 16px;
  font-weight: bold;
  color: #00d3ff;
}

.count-label {
  font-size: 12px;
  color: #ccc;
  /* margin-top: 5px; */
}

.vacancy-list {
  flex: 1;
}

.vacancy-title {
  font-size: 12px;
  font-weight: bold;
  color: #00d3ff;
  margin-bottom: 0px;
  margin-right: 10px;
  text-align: right;
}

.vacancy-item {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 5px;
  padding: 0px 10px;
}

.vacancy-name {
  width: 60px;
  color: #fff;
  font-size: 14px;
}

.vacancy-post {
  width: 90px;
  color: #ccc;
  font-size: 12px;
  
}

.vacancy-bar {
  flex: 1;
  height: 8px;
  background: rgba(0, 211, 255, 0.2);
  border-radius: 4px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  background: #00d3ff;
  border-radius: 4px;
}

.vacancy-value {
  width: 30px;
  text-align: right;
  color: #00d3ff;
  font-weight: bold;
  font-size: 14px;
}

/* 底部车间状态 */
.bottom-workshop {
  height: 90px;
  display: flex;
  gap: 10px;
  padding: 0 10px 5px;
}

.workshop-card {
  flex: 1;
  background: rgba(10, 26, 48, 0.8);
  border: 1px solid rgba(0, 211, 255, 0.3);
  border-radius: 4px;
  padding: 3px 10px;
  display: flex;
  flex-direction: column;
}

.workshop-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
}

.workshop-name {
  font-size: 14px;
  font-weight: bold;
  color: #00d3ff;
}

.detail-btn {
  color: #00d3ff;
  font-size: 12px;
}

.workshop-stats {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.stat-row {
  display: flex;
  justify-content: space-around;
  margin-top: 5px;
}

.stat-col {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-label {
  font-size: 12px;
  color: #ccc;
  margin-bottom: 0px;
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
}

.stat-value.total { color: #00d3ff; }
.stat-value.work { color: #00ff88; }
.stat-value.wait { color: #ffc107; }
.stat-value.fault { color: #ff4d4f; }
.stat-value.stop { color: #86909c; }

/* 页脚 */
.footer {
  height: 30px;
  line-height: 30px;
  text-align: right;
  padding-right: 20px;
  color: #ccc;
  font-size: 12px;
  border-top: 1px solid rgba(0, 211, 255, 0.3);
}

/* 响应式适配 */
@media screen and (max-width: 860px) {
  .env-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}


</style>